import {reportsConstants} from '../_actions/reports.actions';

const initialState = {
    reportedUsers: {},
    reportedDishes: {},
};


export function report(state = initialState, action) {
    switch (action.type) {
        case reportsConstants.GET_REASONS_SUCCESS:
            return {
                ...state,
                reasons: action.getReasonsSuccess,
            };

        case reportsConstants.GET_REPORTED_USERS_SUCCESS:
            return {
                ...state,
                reportedUsers: action.getReportedUsersSuccess,
            };

        case reportsConstants.GET_REPORTED_DISHES_SUCCESS:
            return {
                ...state,
                reportedDishes: action.getReportedDishesSuccess,
            };

        default:
            return {
                ...state,
            };
    }
}
